import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@primer/react';
import LTTooltip from '../LTTooltip/index.js';
import LTText from '../LTText/index.js';
import LTPopover from '../LTPopover/index.js';
import LTTagGroup from '../LTTagGroup/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid ", ";\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  padding: 16px;\n"])), themeGet("colors.border.default"));
var SectionVertical = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-wrap: wrap;\n"])));
var Dot = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 2px;\n  height: 2px;\n  border-radius: 50%;\n  background-color: ", ";\n"])), themeGet("colors.fg.disabled"));
var SectionHorizontal = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n"])));
var Info = function Info(_ref) {
  var item = _ref.item;
  var _ref2 = item || {},
    id = _ref2.id,
    subInfo = _ref2.subInfo,
    tags = _ref2.tags,
    title = _ref2.title,
    type = _ref2.type;
  return /*#__PURE__*/React.createElement(SectionVertical, {
    id: id || ""
  }, /*#__PURE__*/React.createElement(LTText, {
    variant: LTText.TextVariant.SUBHEADER_REGULAR,
    color: "fg.muted"
  }, title), /*#__PURE__*/React.createElement(SectionHorizontal, null, type === "tag" ? /*#__PURE__*/React.createElement(LTTagGroup, {
    tags: tags
  }) : subInfo.map(function (info, index) {
    var name = info.name,
      Icon = info.Icon,
      tooltip = info.tooltip,
      id = info.id;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LTTooltip, {
      text: tooltip || "",
      key: index
    }, /*#__PURE__*/React.createElement(SectionHorizontal, {
      id: id || ""
    }, Icon && /*#__PURE__*/React.createElement(Icon, null), name && /*#__PURE__*/React.createElement(LTText, {
      variant: LTText.TextVariant.SUBHEADER_BOLD
    }, name))), index !== subInfo.length - 1 && /*#__PURE__*/React.createElement(Dot, null));
  })));
};
Info.displayName = "Info";
var LTAutomationHeader = function LTAutomationHeader(_ref3) {
  var list = _ref3.list;
  return /*#__PURE__*/React.createElement(Wrapper, null, list.map(function (item, index) {
    var popoverConfig = item.popoverConfig,
      direction = item.direction,
      popoverWidth = item.popoverWidth,
      popoverContent = item.popoverContent;
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, popoverContent ? /*#__PURE__*/React.createElement(LTPopover, {
      contentStyles: {
        width: popoverWidth ? "".concat(popoverWidth, "px") : "400px"
      },
      direction: direction || LTPopover.Direction.TOP_LEFT,
      popoverConfig: popoverConfig,
      text: popoverContent
    }, /*#__PURE__*/React.createElement(Info, {
      item: item
    })) : /*#__PURE__*/React.createElement(Info, {
      item: item
    }));
  }));
};
LTAutomationHeader.displayName = "LTAutomationHeader";

export { LTAutomationHeader as default };
